import React, { Component } from 'react';
import { Col, Row, Form, FormGroup } from 'reactstrap';
import styles from './Payment.module.css';
import classNames from 'classnames';
import { getLocationFromZip } from '../../api/addressverification';
import SimpleReactValidator from 'simple-react-validator';
import SpinnerButton from '../../shared/SpinnerButton/SpinnerButton';
import SaveModal from '../../../components/modals/SaveModal';
import OrderSummary from '../OrderSummary';
import { BrandingContext } from '../../contexts/ContractContext';
import PaymentBillingInfo from '../../shared/PaymentBillingInfo';
import PaymentInputs from '../../shared/PaymentInputs';
import PaymentAccountInputs from '../../shared/PaymentAccountInputs';
import moment from 'moment';
import axios from 'axios';
import {
    dataLayerPush,
    getCustomerRedirectUrls,
    getMelissaBypassValidation,
    getClientUrl,
    getTokenExDetails
} from '../../../helpers';
import { getMetaDataByClient } from '../../../App';
import CheckboxInput from '../../shared/CheckboxInput/CheckboxInput';
import AIGStatusBadge from '../../shared/StatusBadge/StatusBadge';
import CallBanner from '../../shared/CallBanner/CallBanner';
import getClientContent from '../../_BrandingProvider/brandContent';
import { CancelSaleModal } from '../CancelSaleModal';

let btnLink = 'btnLink';
let tokenExIframe = null;

export class NJRPayment extends Component {
    ccValidation =
        this.props?.location?.state?.planDetails?.clientId?.toLowerCase() === 'njr'
            ? 'required|card_num|invalid_card'
            : 'required';
    constructor(props) {
        super(props);

        this.state = {
            invitationNumber: this.props?.location?.state?.planDetails?.invitationNumber ?? '0',
            amount: this.props?.location?.state?.planDetails?.amount,
            clientId: this.props?.location?.state?.planDetails?.clientId,
            contractNumber: this.props?.location?.state?.planDetails?.contractNumber,
            firstName: this.props?.location?.state?.planDetails?.firstName,
            lastName: this.props?.location?.state?.planDetails?.lastName,
            phone: this.props?.location?.state?.planDetails?.phone,
            email: this.props?.location?.state?.planDetails?.email,
            activeAddPlans: this.props?.location?.state?.planDetails?.activeAddPlans,
            activeAddPlansYearly: this.props?.location?.state?.planDetails?.activeAddPlansYearly,
            planData: this.props?.location?.state?.planDetails?.planData,
            planDetails: this.props?.location?.state?.planDetails,
            ccType: 'unknown',
            ccNumber: '',
            bankAccountType: '',
            bankRoutingNumber: '',
            bankAccountNumber: '',
            states: null,
            cardExpires: '',
            securityCode: '',
            customAddress: false,
            callNumber: '866-258-7419',
            errors: {
                ccInvalid: false,
                ccExpired: false,
                ccNumber: false,
                cardExpires: false,
                securityCode: false,
                billingAddress: false,
                city: false,
                bankAccountType: false,
                bankRoutingNumber: false,
                bankRoutingNumberInvalid: false,
                bankAccountNumber: false,
                bankAccountNumberInvalid: false
            },
            mailingAddress: this.props?.location?.state?.planDetails?.mailingAddress,
            verifiedAddress: this.props?.location?.state?.planDetails?.verifiedAddress,
            billingAddress: this.props?.location?.state?.planDetails?.billingAddress,
            serviceAddress: this.props?.location?.state?.planDetails?.serviceAddress,
            promoCode: {
                name: this.props?.location?.state?.planDetails?.promoCode
            },
            taxAmount: this.props?.location?.state?.planDetails?.taxAmount,
            planDocumentsType: this.props?.location?.state?.planDetails?.planDocumentsType,
            termsAccepted: null,
            payAnnual: false,
            payAmount: 0,
            annualPayAmount: 0,
            validationFired: false,
            bypassBillingMelissaValidation: false,
            isAgent: this.props?.location?.state?.planDetails?.isAgent ?? false,
            paymentType: 'cardPayment',
            showAccountValidations: false,
            tsf: this.props?.location?.state?.planDetails?.tsf,
            cookies: this.props?.location?.state?.cookies,
            enableFindMy: false,
            contractDetails: this.props?.location?.state?.planDetails?.contractData,
            deviceData: this.props?.location?.state?.planDetails?.deviceInfo,
            showCancelSaleModal: false,
            coverageDocsLink: '',
            isTokenExValid: false,
            tokenExId: null,
            tokenExAuthKey: '',
            tokenExTimestamp: '',
            tokenExScheme: '',
            tokenExReferenceNumber: '',
            tokenExFocused: false,
            creditCardLastFour: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.ccTypeChanged = this.ccTypeChanged.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.getCustomerData = this.getCustomerData.bind(this);
        this.getPlanData = this.getPlanData.bind(this);
        this.paymentFailureEmail = this.paymentFailureEmail.bind(this);
        this.achPaymentFailureEmail = this.achPaymentFailureEmail.bind(this);
        this.paymentFailureLog = this.paymentFailureLog.bind(this);
        this.validator = new SimpleReactValidator({
            validators: {
                card_expires: {
                    message: 'The :attribute is invalid.',
                    rule: (val, params, validator) => {
                        return (
                            validator.helpers.testRegex(val, /^(0[1-9]|1[0-2])\/?([0-9]{2})$/)
                            && params.indexOf(val) === -1
                        );
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),
                    required: true
                },
                cvv: {
                    message: 'The :attribute is invalid.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[0-9]{3,4}$/) && params.indexOf(val) === -1;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),
                    required: true
                },
                terms: {
                    message: 'The :attribute is invalid.',
                    rule: (val, params, validator) => {
                        return true;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),
                    required: true
                },
                invalid_card: {
                    message: 'Payment type not accepted.',
                    rule: (val) => {
                        return !(val.startsWith('37') || val.startsWith('34'));
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),
                    required: true
                },
                enableFindMy: {
                    message: 'The :attribute is invalid.',
                    rule: (val, params, validator) => {
                        return val;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),
                    required: true
                }
            },
            element: (message) => (
                <div
                    className='errorMsg'
                    aria-live='polite'
                >
                    {message.charAt(0).toUpperCase() + message.slice(1)}
                </div>
            ),
            messages: {
                card_num: 'The credit card number is invalid.',
                card_exp: 'The :attribute is invalid.',
                terms: 'Please accept terms and conditions before proceed.',
                required: ':attribute is required.',
                invalid_card: 'Payment type not accepted.'
            }
        });
    }
    componentDidMount = () => {
        // prevent page loading at bottom
        window.scrollTo(0, 0);

        const {
            amount,
            taxAmount,
            planDocumentsType,
            taxRate,
            planData: { selectedPlan, selectedAddPlans, activeAddPlans, plan, activePlan }
        } = this.props?.location?.state?.planDetails;
        const additionalPlansForGtm = [];
        selectedAddPlans.map((aP, i) => {
            const addOn = aP.riskProfile;
            additionalPlansForGtm.push({
                item_id: aP.name,
                item_name: addOn.description,
                item_category: 'add_on_plan',
                price: addOn.totalBundlePrice,
                paymentPlan: plan
            });
        });

        dataLayerPush('Pageview', {
            pagePath: '/payment',
            pageTitle: 'NJR Retail Service Plans - Payment'
        });

        dataLayerPush(null, { ecommerce: null });

        dataLayerPush('add_payment_info', {
            ecommerce: {
                currency: 'USD',
                value: Number(parseFloat(amount).toFixed(2)),
                tax: taxAmount,
                payment_type: 'Credit Card',
                coupon: this.state.promoCode.name,
                items: [
                    {
                        item_id: activePlan, // need more of the add plan like on previous screens. Required data not present on the risk profile
                        item_name: selectedPlan.riskProfile?.description,
                        item_category: 'primary_plan',
                        price: selectedPlan.riskProfile?.totalBundlePrice,
                        paymentPlan: plan
                    },
                    ...additionalPlansForGtm
                ]
            }
        });

        this.setState({
            bypassBillingMelissaValidation: getMelissaBypassValidation(1, this.state.clientId)
        });
        this.handleCalculateYearlyPayment();
        this.getCoverageDocsLink();
    };

    getCoverageDocsLink = async () => {
        const data = await getCustomerRedirectUrls(this.state.clientId).then((urlResponse) => {
            return {
                coverageURL: urlResponse?.coverageDocsUrl
            };
        });

        this.setState({
            coverageDocsLink: data?.coverageURL
        });
    };

    handleCalculateYearlyPayment = (e) => {
        const planData = this.props?.location?.state?.planDetails?.planData;

        //const taxRate = 6.625 / 100;
        let addonsPriceLocal = 0;
        let totalPrice = 0;
        if (planData.selectedAddPlans.length) {
            if (planData?.tsf?.name == 'higher') {
                addonsPriceLocal = planData?.activeAddPlansYearly.reduce((accu, cur) => accu + cur.higherTsfPrice, 0);
            } else if (planData?.tsf?.name == 'lower') {
                addonsPriceLocal = planData?.activeAddPlansYearly.reduce((accu, cur) => accu + cur.lowerTsfPrice, 0);
            } else {
                addonsPriceLocal = planData?.activeAddPlansYearly.reduce(
                    (accu, cur) => accu + cur.riskProfile.totalBundlePrice,
                    0
                );
            }
        }
        addonsPriceLocal = addonsPriceLocal.toFixed(2);
        const basePlan = parseFloat(planData.annualPlanTotal).toFixed(2);
        const totalTax = parseFloat(
            (
                (parseFloat(basePlan) + parseFloat(addonsPriceLocal))
                * parseFloat(this.props?.location?.state?.planDetails?.taxRate)
            ).toFixed(2)
        );
        totalPrice = parseFloat(parseFloat(basePlan) + parseFloat(addonsPriceLocal) + parseFloat(totalTax)).toFixed(2);
        this.setState({
            annualPayAmount: totalPrice
        });
    };
    handleCheckAddress = (e) => {
        const { checked } = e.target;
        this.setState({
            customAddress: !checked
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeAddPlans !== this.state.activeAddPlans) {
            this.handleCalculateYearlyPayment();
        }
    }

    ccTypeChanged(type) {
        switch (type) {
            case 'visa':
                break;
            case 'mastercard':
                break;
            case 'amex':
                break;
            case 'discover':
                break;
            default:
                type = 'unknown';
                break;
        }
        this.setState(() => ({
            ccType: type
        }));
    }

    handleToggle = (check) => {
        this.setState({ ShowSaveModal: false });
    };

    getCustomerData = () => {
        const customerData = {
            invitationNumber: this.state.invitationNumber,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phone: this.state.phone,
            email: this.state.email,
            serviceAddress: this.state.serviceAddress,
            mailingAddress: this.state.mailingAddress,
            billingAddress: this.state.billingAddress,
            doNotSolicit: this.props.location.state?.planDetails?.doNotSolicit,
            termsAndCondition: this.state.termsAccepted,
            payAnnually: this.state.payAnnual,
            isMailingAddress: false,
            plan: null
        };

        return customerData;
    };

    getPlanData = () => {
        const planData = this.state.planData;
        return planData;
    };

    handleSavedData = (isSaved, invitationNumber) => {
        if (isSaved) {
            this.props.history.push({
                pathname: '/confirmation/2',
                state: { invitationNumber: invitationNumber }
            });
        }
    };

    handleAnnualPay = () => {
        if (!this.state.payAnnual) {
            this.setState({
                payAnnual: true
            });
        } else {
            this.setState({ payAnnual: false });
        }
    };

    handleTermsToggle = () => {
        if (!this.state.termsAccepted) {
            this.setState({
                termsAccepted: true
            });
        } else {
            this.setState({ termsAccepted: null });
        }
    };

    handleBackbutton = () => {
        if (this.state.clientId?.toLowerCase() === 'njr') {
            this.props.history.push('/ReviewPlanDetails');
        } else {
            this.props.history.push('/customerinfo');
        }
    };

    pullLocationInfoFromZip = (zip) => {
        if (zip.length >= 5) {
            getLocationFromZip(zip, this.state.clientId, this.onZipVerified, this.state.cookies);
        }
    };

    async componentWillMount() {
        fetch('api/party/states/' + this.state.clientId)
            .then((res) => res.json())
            .then((data) => {
                this.setState({
                    states: data.map((s) => {
                        return {
                            data: s.stateId,
                            display: s.name,
                            abbreviation: s.abbreviation
                        };
                    })
                });
            });

        // get Tokenx API details
        let tokenExStatusCode = 0;
        getTokenExDetails(window.location.origin)
            .then(function (res) {
                tokenExStatusCode = res.status;
                return res.json();
            })
            .then((data) => {
                if (tokenExStatusCode === 200) {
                    this.setState({
                        tokenExId: data?.tokenExId,
                        tokenExAuthKey: data?.authenticationKey,
                        tokenExTimestamp: data?.timeStamp,
                        tokenExScheme: data?.tokenScheme
                    });

                    this.handleTokenExIframeLoad();
                }
            });
    }

    handleTokenExcardTypeChange = (data) => {
        console.log('CC iFrame cardTypeChange');
        let ccTypeTokenEx = data?.possibleCardType ?? data?.cardType;
        let ccType = 'unknown';
        switch (ccTypeTokenEx) {
            case 'visa':
                ccType = 'visa';
                break;
            case 'masterCard':
                ccType = 'mastercard';
                break;
            case 'americanExpress':
                ccType = 'amex';
                break;
            case 'discover':
                ccType = 'discover';
                break;
            default:
                ccType = 'unknown';
                break;
        }

        let errors = this.state.errors;
        let ccNotSupported = ccType === 'unknown' ? true : false;
        errors['ccInvalid'] = ccNotSupported;

        this.setState(() => ({
            ccType: ccType,
            errors: errors
        }));
    };

    handleTokenExChange = () => {
        console.info('Iframe value changed');
        this.setState({
            ccNumberToken: ''
        });
        tokenExIframe.validate();
    };

    handleTokenExValidation = (data) => {
        console.info('Iframe validation');
        let errors = this.state.errors;
        errors['ccNumber'] = data?.validator === 'required' ? true : false;
        errors['ccInvalid'] = data?.validator === 'format' ? true : false;
        this.setState({
            isTokenExValid: data?.isValid && !this.state.errors.ccNotSupported,
            errors: errors,
            ccNumber: data?.firstSix ?? null
        });
    };

    handleTokenExFocus = () => {
        this.setState({
            tokenExFocused: true
        });
    };
    handleTokenExBlur = () => {
        this.setState({
            tokenExFocused: false
        });
        if (!this.state.errors.ccNotSupported) tokenExIframe.tokenize();
    };

    handleTokenize = (data) => {
        console.log('CC iFrame Tokenize');
        if (data?.token) {
            this.setState({
                ccNumberToken: data.token,
                ccNumber: data.token,
                tokenExReferenceNumber: data.referenceNumber,
                creditCardLastFour: data.lastFour,
                isTokenExValid: true
            });
        }
    };

    SetupIframeEvents = (iframe) => {
        iframe.on('load', function () {
            console.info('Iframe loaded');
        });

        iframe.on('focus', this.handleTokenExFocus);

        iframe.on('blur', this.handleTokenExBlur);

        iframe.on('validate', this.handleTokenExValidation);

        iframe.on('change', this.handleTokenExChange);

        iframe.on('cardTypeChange', this.handleTokenExcardTypeChange);

        iframe.on('error', function (data) {
            console.log('CC iFrame error:' + JSON.stringify(data));
        });

        iframe.on('tokenize', this.handleTokenize);
    };

    handleTokenExIframeLoad = () => {
        let tokenExDiv = document.getElementById('tokenEx-iframe-div');
        if (tokenExDiv && this.state.tokenExId) {
            const cardMaxLengths = {
                visa: 16,
                mastercard: 16,
                americanExpress: 15,
                discover: 16,
                diners: 16,
                jcb: 19
            };
            let iframeConfig = {
                styles: {
                    base: 'border: none',
                    focus: 'outline-color: white'
                },
                origin: window.location.origin,
                timestamp: this.state.tokenExTimestamp,
                tokenExID: this.state.tokenExId,
                tokenScheme: this.state.tokenExScheme,
                authenticationKey: this.state.tokenExAuthKey,
                pci: true,
                //enableAriaRequired: true,
                //placeholder: "cc-number",
                maskInput: true,
                inputType: 'text',
                enablePrettyFormat: true,
                inputMaxLength: 16,
                cardMaxLengths: cardMaxLengths,
                debug: false
            };
            tokenExIframe = new window.TokenEx.Iframe('tokenEx-iframe-div', iframeConfig);
            //add event listeners
            this.SetupIframeEvents(tokenExIframe);
            tokenExIframe.load();
            this.setState({
                tokenExIframeLoaded: true
            });
        }
        return '';
    };

    onZipVerified = (result) => {
        if (result.successful) {
            let state = this.state.states.find(({ abbreviation }) => abbreviation === result.location.state).data;
            let billingAddress = this.state.billingAddress;
            billingAddress.stateId = state;
            billingAddress.city = result.location.city;
            this.setState({
                billingAddress: billingAddress
            });
        }
    };

    handleStateDropDown = (e) => {
        let billingAddress = this.state.billingAddress;
        billingAddress['stateId'] = e;
        billingAddress['state'] = this.state.states.find((state) => {
            return state.data == e;
        }).abbreviation;
        this.setState({ billingAddress: billingAddress });
    };

    handleShowActionModal = (event) => {
        event.preventDefault();
        this.setState({ ShowSaveModal: true });
    };

    updateAmount = (a) => {
        this.setState({ amount: a });
    };

    updatePromoCode = (a) => {
        this.setState({ promoCode: a });
    };

    updatePlanData = (p) => {
        this.setState({
            activeAddPlans: p.activeAddPlans,
            activeAddPlansYearly: p.activeAddPlansYearly,
            planData: {
                ...this.state.planData,
                selectedAddPlans: p.planData.selectedAddPlans,
                selectedPlan: p.planData.selectedPlan,
                activeAddPlansYearly: p.planData.activeAddPlansYearly
            }
        });
    };
    updatePayAmount = (payAmount) => {
        if (this.state.amount != payAmount) {
            this.setState({ amount: payAmount });
        }
    };

    handleInputChange = (e) => {
        let { name, value } = e.target;
        let fieldName = name;
        let errors = this.state.errors;
        let billingAddress = this.state.billingAddress;
        let validations = 'required';

        if (name === 'ccNumber') {
            value = e.target.value;
        }
        if (name === 'cardExpires') {
            value = e.target.rawValue;
        }

        if (name === 'zipCode') {
            this.pullLocationInfoFromZip(value);
        }

        switch (name) {
            //case "ccNumber":
            //    errors["ccInvalid"] = false;
            //    fieldName = "creditCardNumber";
            //    validations = this.ccValidation;
            //    break;
            case 'cardExpires':
                errors['ccExpired'] = false;
                fieldName = 'expirationDate';
                validations = 'required|card_expires|min:4';
                break;
            case 'securityCode':
                fieldName = 'securityCode';
                validations = 'required|cvv';
                break;
            case 'billingAddress':
                fieldName = 'billingAddress';
                billingAddress['address1'] = value;
                validations = this.state.selectedAddress == 'billingAddress' ? 'required' : '';
                break;
            case 'billingAddress2':
                billingAddress['address2'] = value;
                validations = this.state.selectedAddress == 'billingAddress' ? 'required' : '';
                break;
            case 'city':
                billingAddress[name] = value;
                validations = this.state.selectedAddress == 'billingAddress' ? 'required' : '';
                break;
            case 'state':
                validations = this.state.selectedAddress == 'billingAddress' ? 'required' : '';
                break;
            case 'zipCode':
                fieldName = 'Zip/Postal code';
                billingAddress['zip'] = value;
                validations = this.state.selectedAddress == 'billingAddress' ? 'required' : '';
                break;
            case 'bankRoutingNumber':
                if (value?.length > 9) {
                    value = value.substring(0, 9);
                }
                validations = 'required|size:9';
                errors['bankRoutingNumberInvalid'] = false;
                break;
            case 'bankAccountNumber':
                if (value?.length > 17) {
                    value = value.substring(0, 17);
                }
                validations = 'required|max:17';
                errors['bankAccountNumberInvalid'] = false;
                break;
            default:
                break;
        }

        errors[name] = !this.validator.check(value, validations);

        errors['bankRoutingNumber'] = false;
        errors['bankRoutingNumberInvalid'] = false;
        errors['bankAccountNumber'] = false;

        this.setState({
            [name]: value,
            billingAddress: billingAddress,
            errors: errors
        });
    };

    paymentFailureEmail = (email, contractId) => {
        var emailModel = { recipients: [email], cc: [], bcc: [], emailType: 48, IsBodyHtml: true };
        var serviceModel = {
            CustomerName: this.state.firstName + ' ' + this.state.lastName,
            PaymentDate: moment().format('MMMM DD,YYYY'),
            PurchaseTotalAmount: this.state.amount,
            PlanType: this.state.selectedPlan,
            WarrantyObjectTypeId: 1,
            ClaimId: contractId
        };
        axios
            .post(`api/communication/${this.state.clientId}`, {
                emailModel: emailModel,
                serviceModel: serviceModel
            })
            .then((emailResponse) => {
                console.debug(emailResponse);
            });
    };

    achPaymentFailureEmail = async (email, contractId) => {
        await axios
            .post(`api/Contract/UpdateContractStatus/${contractId}/${11}/${this.state.clientId}`)
            .then((Response) => {
                console.debug(Response);
            });

        let paymentUrl = '';
        const clientUrlPromise = await getClientUrl(this.state.clientId).then((urlResp) => {
            paymentUrl = urlResp.url;
        });

        let miniSiteUrl = paymentUrl.url + '/resumequote/Payment/' + parseInt(contractId) + '/' + this.state.clientId;
        var description = this.state.activeAddPlans?.map((x) => x.description)?.join(',');
        var emailModel = { recipients: [email], cc: [], bcc: [], emailType: 155, IsBodyHtml: true };
        var serviceModel = {
            CustomerName: this.state.firstName + ' ' + this.state.lastName,
            ClientContractNumber: this.state.invitationNumber,
            PaymentDate: moment().format('MMMM DD,YYYY'),
            InitialPayment: this.state.amount,
            EnrollmentProgram: this.state.planData.selectedPlan.riskProfile.description,
            AdditionalOptions: description,
            ClaimId: contractId,
            MiniSiteURL: miniSiteUrl
        };
        axios
            .post(`api/communication/${this.state.clientId}`, {
                emailModel: emailModel,
                serviceModel: serviceModel
            })
            .then((emailResponse) => {
                console.debug(emailResponse);
            });
    };

    achPaymentFailureEmail = async (email, contractId) => {
        await axios
            .post(`api/Contract/UpdateContractStatus/${contractId}/${11}/${this.state.clientId}`)
            .then((Response) => {
                console.debug(Response);
            });

        let paymentUrl = '';
        const clientUrlPromise = await getClientUrl(this.state.clientId).then((urlResp) => {
            paymentUrl = urlResp.url;
        });

        let miniSiteUrl = paymentUrl.url + '/resumequote/Payment/' + parseInt(contractId) + '/' + this.state.clientId;
        var description = this.state.activeAddPlans?.map((x) => x.description)?.join(',');
        var emailModel = { recipients: [email], cc: [], bcc: [], emailType: 155, IsBodyHtml: true };
        var serviceModel = {
            CustomerName: this.state.firstName + ' ' + this.state.lastName,
            ClientContractNumber: this.state.invitationNumber,
            PaymentDate: moment().format('MMMM DD,YYYY'),
            InitialPayment: this.state.amount,
            EnrollmentProgram: this.state.planData.selectedPlan.riskProfile.description,
            AdditionalOptions: description,
            ClaimId: contractId,
            MiniSiteURL: miniSiteUrl
        };
        axios
            .post(`api/communication/${this.state.clientId}`, {
                emailModel: emailModel,
                serviceModel: serviceModel
            })
            .then((emailResponse) => {
                console.debug(emailResponse);
            });
    };

    paymentFailureLog = (contractId, paymentType) => {
        var historyNotes = '';

        if (paymentType == 'cardPayment') {
            historyNotes = 'Payment was not processed and failed for the plan purchase.';
        } else {
            historyNotes = 'Payment was not processed and failed for the plan purchase.';
        }

        axios
            .post(
                `api/history/CreateContractPaymentLog/${this.state.clientId}/${contractId}/${'Contract Updated'}/${historyNotes}`,
                {},
                {
                    headers: {
                        XSRFTOKEN: this.state.cookies.XSRFTOKEN
                    }
                }
            )
            .then((Response) => {
                console.debug(Response);
            });
    };

    checkPaymentSpecificValidations = () => {
        const { bankRoutingNumber, bankAccountType, bankAccountNumber, termsAccepted, clientId } = this.state;
        const { address1, city, zip } = this.state.billingAddress;
        let zipLength = true;
        if (zip?.length < 5) zipLength = false;
        const {
            //creditCardNumber,
            expirationDate,
            securityCode,
            termsandconditions,
            enableFindMy
        } = this.validator.fields; //check for field validation

        if (this.state.paymentType === 'cardPayment') {
            if (clientId?.toLowerCase() === 'apple') {
                return (
                    this.state.isTokenExValid
                    && expirationDate
                    && securityCode
                    && termsandconditions
                    && address1
                    && city
                    && zip
                    && zipLength
                    && this.state.ccType !== 'unknown'
                    && enableFindMy
                    && true
                );
            } else {
                return (
                    this.state.isTokenExValid
                    && expirationDate
                    && securityCode
                    && termsandconditions
                    && address1
                    && city
                    && zip
                    && zipLength
                    && this.state.ccType !== 'unknown'
                    && true
                );
            }
        } else {
            if (
                bankRoutingNumber
                && bankRoutingNumber.length === 9
                && bankAccountType
                && bankAccountNumber
                && address1
                && city
                && zip
                && zipLength
                && termsAccepted
            ) {
                return true;
            }
            return false;
        }
    };

    continue = (e) => {
        e.preventDefault();
        if (this.checkPaymentSpecificValidations()) {
            // Clear previous errors
            let errors = this.state.errors;
            for (var key of Object.keys(errors)) {
                errors[key] = false;
            }

            this.setState({ errors: errors, searching: true, validationFired: true });

            if (this.state.clientId?.toLowerCase() === 'apple') {
                this.processPayment();
            } else {
                /* SEU-3377 CREATE Contract */

                let formData = {
                    invitationNumber: this.state.invitationNumber ?? '0',
                    firstName: this.state.firstName ? this.state.firstName : '',
                    lastName: this.state.lastName ? this.state.lastName : '',
                    phone: this.state.phone ? this.state.phone : '',
                    email: this.state.email ? this.state.email : '',
                    serviceAddress: this.state.serviceAddress,
                    mailingAddress: this.state.mailingAddress,
                    billingAddress: this.state.billingAddress,
                    doNotSolicit: this.props.location?.state?.planDetails?.doNotSolicit,
                    termsAndCondition: this.state.termsAndCondition,
                    riskProfileModel: this.state.payAnnual
                        ? this.props.location?.state?.planDetails?.yearlyRiskProfileModel
                        : this.props.location?.state?.planDetails?.riskProfileModel,
                    activeAddPlans: this.state.payAnnual ? this.state.activeAddPlansYearly : this.state.activeAddPlans,
                    isPayment: true,
                    autoRenewal: false,
                    promoCode: this.state.promoCode?.name,
                    planDocumentsType: this.state.planDocumentsType,
                    tsfAmount: parseFloat(this.state.tsf)?.toFixed(2),
                    savedStep: '',
                    isACHPayment: this.state.paymentType == 'bankPayment' ? true : false
                };
                let statusCode = 0;
                fetch(`api/Contract/CreatePlanContract/${this.state.clientId}/${this.state.isAgent}`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        XSRFTOKEN: this.state.cookies.XSRFTOKEN
                    },
                    body: JSON.stringify(formData)
                })
                    .then(function (res) {
                        statusCode = res.status;
                        return res.json();
                    })
                    .then((contractData) => {
                        if (statusCode === 204) {
                        }
                        if (statusCode === 200) {
                            this.setState({
                                invitationNumber: contractData.clientContractNumber
                            });

                            let contractNumber = contractData.contractNumber;
                            let address = this.state.billingAddress;
                            let mailingAddress = this.state.serviceAddress;
                            const ccTypeId = this.getCCTypeId();
                            const cardDetails = this.checkCCExpiry();

                            if (cardDetails.isExpired) {
                                errors['ccExpired'] = true;
                                this.setState({ errors: errors, searching: false });
                                return;
                            }
                            let statusCode = '';

                            // keep spinner active while fetching
                            this.setState({
                                searching: true,
                                paymentAddress: address,
                                ccTypeId: ccTypeId
                            });

                            let amount = 0;
                            var resultData = {
                                Amount: parseFloat(this.state.amount),
                                taxAmount: parseFloat(this.state.taxAmount),
                                CardHolder: {
                                    FirstName: this.state.firstName,
                                    LastName: this.state.lastName,
                                    SelectedAddress: this.state.selectedAddress,
                                    BillingAddress: {
                                        StreetAddress: address.address1,
                                        Locality: address.city,
                                        Region: this.state.states.find((state) => {
                                            return state.data == address.stateId;
                                        }).abbreviation,
                                        PostalCode: address.zip.substring(0, 5),
                                        ThreeLetterIsoCode: 'USA'
                                    },
                                    ShippingAddress: {
                                        StreetAddress: address.address1,
                                        Locality: address.city,
                                        Region: this.state.states.find((state) => {
                                            return state.data == mailingAddress.stateId;
                                        }).abbreviation,
                                        PostalCode: address.zip.substring(0, 5),
                                        ThreeLetterIsoCode: 'USA'
                                    }
                                },
                                CardInfo: null,
                                CurrencyCode: 'USD',
                                RelatedTo: 1,
                                CultureName: 'en-US',
                                RelatedToIds: [contractNumber],
                                PaymentType: this.state.paymentType,
                                BankAccountNumber: this.state.bankAccountNumber,
                                BankRoutingNumber: this.state.bankRoutingNumber,
                                BankAccountType:
                                    this.state.bankAccountType == 'savings'
                                        ? 'ESAV'
                                        : this.state.bankAccountType == 'checking'
                                          ? 'ECHK'
                                          : ''
                            };

                            var chargeData = {
                                Amount: parseFloat(this.state.amount),
                                taxAmount: parseFloat(this.state.taxAmount),
                                CardHolder: {
                                    FirstName: this.state.firstName,
                                    LastName: this.state.lastName,
                                    SelectedAddress: this.state.selectedAddress,
                                    BillingAddress: {
                                        StreetAddress: address.address1,
                                        Locality: address.city,
                                        Region: this.state.states.find((state) => {
                                            return state.data == address.stateId;
                                        }).abbreviation,
                                        PostalCode: address.zip.substring(0, 5),
                                        ThreeLetterIsoCode: 'USA'
                                    },
                                    ShippingAddress: {
                                        StreetAddress: address.address1,
                                        Locality: address.city,
                                        Region: this.state.states.find((state) => {
                                            return state.data == mailingAddress.stateId;
                                        }).abbreviation,
                                        PostalCode: address.zip.substring(0, 5),
                                        ThreeLetterIsoCode: 'USA'
                                    }
                                },
                                CardInfo: {
                                    FullNumber: this.state.ccNumber.replace('-', ''),
                                    ExpirationMonth: parseInt(cardDetails.month),
                                    ExpirationYear: parseInt('20' + cardDetails.year),
                                    CreditCardVerificationNumber: this.state.securityCode,
                                    CardType: ccTypeId
                                },
                                CurrencyCode: 'USD',
                                RelatedTo: 1,
                                CultureName: 'en-US',
                                RelatedToIds: [contractNumber],
                                PaymentType: this.state.paymentType
                            };

                            // call payment service
                            fetch('api/payment/'.concat(this.state.clientId), {
                                method: 'post',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(this.state.paymentType === 'cardPayment' ? chargeData : resultData)
                            })
                                .then(function (res) {
                                    statusCode = res.status;
                                    if (statusCode == 500) {
                                        let errors = this.state.errors;
                                        errors['general'] = true;
                                        this.setState({ searching: false, errors: errors }, () => {
                                            // trigger email
                                            if (this.state.paymentType === 'cardPayment') {
                                                this.paymentFailureEmail(formData.email, contractData.contractId);
                                            } else {
                                                this.achPaymentFailureEmail(formData.email, contractData.contractId);
                                            }

                                            this.paymentFailureLog(contractData.contractId, 'cardPayment');
                                            // Show error messages
                                            console.error(statusCode);
                                            return;
                                        });
                                    }
                                    return res.json();
                                })
                                .then((data) => {
                                    if (statusCode === 204) {
                                        let errors = this.state.errors;
                                        errors['general'] = true;
                                        this.setState({ searching: false, errors: errors }, () => {
                                            // Show error messages
                                            // trigger email
                                            if (this.state.paymentType === 'cardPayment') {
                                                this.paymentFailureEmail(formData.email, contractData.contractId);
                                                this.paymentFailureLog(contractData.contractId, 'cardPayment');
                                            } else {
                                                this.achPaymentFailureEmail(formData.email, contractData.contractId);
                                                this.paymentFailureLog(contractData.contractId, 'ach');
                                            }
                                            return;
                                        });
                                    } else if (statusCode === 200) {
                                        if (!data.isSuccessful) {
                                            let errorsResponse = data.errors;
                                            if (errorsResponse.length > 0) {
                                                errorsResponse.map(function (error) {
                                                    if (error.errorCode === '9576') {
                                                        errors['ccInvalid'] = true;
                                                    } else if (error.errorCode.includes('EXPIRED')) {
                                                        errors['ccExpired'] = true;
                                                    } else if (error.errorCode.includes('FUND')) {
                                                        errors['funds'] = true;
                                                    } else if (error.errorCode.includes('ADDRESS')) {
                                                        errors['billingAddressMatch'] = true;
                                                    } else if (error.errorCode.includes('DECLINED')) {
                                                        errors['declined'] = true;
                                                    } else if (
                                                        error.rawErrorMessage.toLowerCase().includes('bad card check')
                                                    ) {
                                                        errors['ccInvalid'] = true;
                                                    } else if (
                                                        error.rawErrorMessage.toLowerCase().includes('call for auth')
                                                    ) {
                                                        errors['ccInvalid'] = true;
                                                    } else if (
                                                        error.rawErrorMessage.toLowerCase().includes('do not honor')
                                                    ) {
                                                        errors['declined'] = true;
                                                    } else if (
                                                        error.rawErrorMessage.toLowerCase().includes('expired')
                                                    ) {
                                                        errors['ccExpired'] = true;
                                                    } else if (
                                                        error.rawErrorMessage.toLowerCase().includes('decline')
                                                    ) {
                                                        errors['funds'] = true;
                                                    } else if (
                                                        error.rawErrorMessage.toLowerCase().includes('timed out')
                                                    ) {
                                                        errors['general'] = true;
                                                    } else if (
                                                        error.rawErrorMessage
                                                            .toLowerCase()
                                                            .includes('is not a valid routing number')
                                                    ) {
                                                        errors['bankRoutingNumber'] = true;
                                                        errors['bankRoutingNumberInvalid'] = true;
                                                    } else if (
                                                        error.rawErrorMessage
                                                            .toLowerCase()
                                                            .includes('account failed smartdetect validation')
                                                        || error.rawErrorMessage
                                                            .toLowerCase()
                                                            .includes('must be between 4 and 17 digits long')
                                                        || error.rawErrorMessage
                                                            .toLowerCase()
                                                            .includes('invalid checking account number')
                                                    ) {
                                                        errors['bankAccountNumber'] = true;
                                                        errors['bankAccountNumberInvalid'] = true;
                                                    } else {
                                                        errors['general'] = true;
                                                    }
                                                });
                                                // trigger email
                                                if (this.state.paymentType === 'cardPayment') {
                                                    this.paymentFailureEmail(formData.email, contractData.contractId);
                                                    this.paymentFailureLog(contractData.contractId, 'cardPayment');
                                                } else {
                                                    this.achPaymentFailureEmail(
                                                        formData.email,
                                                        contractData.contractId
                                                    );
                                                    this.paymentFailureLog(contractData.contractId, 'ach');
                                                }
                                                this.setState({ errors: errors, searching: false, paymentError: true });

                                                return;
                                            }
                                        }

                                        if (this.state.amount > 1) {
                                            let historyNotes =
                                                'Deductible collected in amount of ${' + this.state.amount + '}';
                                        }

                                        let riskProfileName = formData.riskProfileModel.name;

                                        if (formData.riskProfileModel.name.toLowerCase().includes('kitchen and laun')) {
                                            riskProfileName = 'Total Appliance Bundle';
                                        } else if (
                                            formData.riskProfileModel.name.toLowerCase().includes('kitchen bundle')
                                        ) {
                                            riskProfileName = 'Kitchen Appliances';
                                        } else if (
                                            formData.riskProfileModel.name.toLowerCase().includes('laun')
                                            && formData.riskProfileModel.name.toLowerCase().includes('bundle')
                                        ) {
                                            riskProfileName = 'Laundry Appliances';
                                        } else {
                                            riskProfileName = formData.riskProfileModel.name;
                                        }

                                        const {
                                            planData: {
                                                selectedPlan,
                                                selectedAddPlans,
                                                activeAddPlans,
                                                plan,
                                                activePlan
                                            }
                                        } = this.props?.location?.state?.planDetails;

                                        // CREATE ARRAY OF ITEMS FOR ENHANCED ECOMMERCE
                                        const additionalPlansForGtm = () => {
                                            const gtmAddOnArray = [];
                                            selectedAddPlans
                                                && selectedAddPlans.length
                                                && selectedAddPlans.map((aP, i) => {
                                                    const addOn = aP.riskProfile;
                                                    gtmAddOnArray.push({
                                                        item_id: activeAddPlans[i],
                                                        item_name: addOn.description,
                                                        item_category: 'add_on_plan',
                                                        price: addOn.totalBundlePrice,
                                                        paymentPlan: plan
                                                    });
                                                });
                                            return gtmAddOnArray;
                                        };
                                        // LOG PURCHASE TO GA ENHANCED ECOMMERCE
                                        dataLayerPush(null, { ecommerce: null });
                                        dataLayerPush('purchase', {
                                            ecommerce: {
                                                currency: 'USD',
                                                value: parseFloat(this.state.amount).toFixed(2),
                                                tax: this.state.taxAmount,
                                                transaction_id: contractData.contractNumber,
                                                coupon: this.state.promoCode.name,
                                                items: [
                                                    {
                                                        item_id: activePlan, // need more of the add plan like on previous screens. Required data not present on the risk profile
                                                        item_name: riskProfileName,
                                                        item_category: 'primary_plan',
                                                        price: selectedPlan?.riskProfile?.totalBundlePrice,
                                                        paymentPlan: plan
                                                    },
                                                    ...additionalPlansForGtm()
                                                ]
                                            }
                                        });

                                        // THEN REROUTE TO CONFIRMATION SCREEN
                                        this.props.history.push({
                                            pathname: '/confirmation/3',
                                            state: {
                                                invitationNumber: contractData.contractNumber,
                                                isYearly:
                                                    this.state.payAnnual == true
                                                        ? true
                                                        : formData.riskProfileModel.name
                                                              .toLowerCase()
                                                              .includes('annual'),
                                                amount: this.state.amount,
                                                taxAmount: this.state.taxAmount,
                                                riskProfileName: riskProfileName,
                                                isPayment: true,
                                                isSaved: true,
                                                selectedPlan,
                                                selectedAddPlans,
                                                activeAddPlans,
                                                plan,
                                                activePlan,
                                                promoCode: this.state.promoCode.name,
                                                paymentType: this.state.paymentType
                                            }
                                        });

                                        contractData.statusId = 1;
                                        contractData.riskProfile = formData.riskProfileModel;
                                        contractData.addOns = formData.activeAddPlans;
                                        contractData.finalPlanAmount = formData.riskProfileModel.totalBundlePrice;
                                        contractData.totalPaidAmount = this.state.amount;
                                        contractData.taxAmount = this.state.taxAmount;
                                        contractData.emailAddress = formData.email;
                                        contractData.customerName = formData.firstName + ' ' + formData.lastName;
                                        contractData.riskProfileName = riskProfileName;
                                        contractData.isAnnualPay = this.state.payAnnual;
                                        contractData.paymentType = this.state.paymentType;

                                        fetch(`api/Contract/SetPlanActive/${this.state.clientId}`, {
                                            method: 'post',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify(contractData)
                                        });
                                    } else {
                                        let errors = this.state.errors;
                                        errors['general'] = true;
                                        this.setState({ searching: false, errors: errors }, () => {
                                            // trigger email
                                            if (this.state.paymentType === 'cardPayment') {
                                                this.paymentFailureEmail(formData.email, contractData.contractId);
                                                this.paymentFailureLog(contractData.contractId, 'cardPayment');
                                            } else {
                                                this.achPaymentFailureEmail(formData.email, contractData.contractId);
                                                this.paymentFailureLog(contractData.contractId, 'ach');
                                            }
                                            // Show error messages
                                            console.error(statusCode);
                                            return;
                                        });
                                    }
                                });
                        }
                    });
            }
        } else {
            let errors = this.state.errors;
            let state = this.state;
            let fieldName = '';
            let validations = '';

            if (this.state.paymentType === 'cardPayment') {
                for (let [key, value] of Object.entries(state)) {
                    switch (key) {
                        case 'ccNumber':
                            fieldName = 'creditCardNumber';
                            validations = this.ccValidation;
                            break;
                        case 'cardExpires':
                            fieldName = 'expirationDate';
                            validations = 'required|card_expires|min:4';
                            break;
                        case 'securityCode':
                            fieldName = 'securityCode';
                            validations = 'required|cvv';
                            break;
                        case 'billingAddress':
                            fieldName = 'billingAddress';
                            validations = this.state.selectedAddress == 'billingAddress' ? 'required' : '';
                            break;
                        default:
                            break;
                    }
                    errors[key] = !this.validator.check(value, validations);
                }
                if (this.state.ccType === 'unknown' && !errors['ccNumber']) {
                    errors['ccInvalid'] = true;
                }
                this.validator.showMessages();
                this.forceUpdate();
            } else {
                this.setState({ showAccountValidations: true });
                for (let [key, value] of Object.entries(state)) {
                    let validations =
                        key === 'billingAddress'
                            ? this.state.selectedAddress == 'billingAddress'
                                ? 'required'
                                : ''
                            : 'required';

                    if (
                        key !== 'ccNumber'
                        && key !== 'cardExpires'
                        && key !== 'securityCode'
                        && key !== 'bankAccountNumber'
                        && key !== 'bankRoutingNumber'
                    ) {
                        errors[key] = !this.validator.check(value, validations);
                    }
                    if (key === 'bankRoutingNumber') {
                        errors['bankRoutingNumber'] = !this.validator.check(value, 'required|size:9');
                    }

                    if (key === 'bankAccountNumber') {
                        errors[key] = !this.validator.check(value, 'required|max:17');
                    }
                }
                //show error messages for bank account payment type
                this.validator.showMessageFor('accountNumber');
                this.validator.showMessageFor('routingNumber');
                this.validator.showMessageFor('accountType');
                this.validator.showMessageFor('billingAddress');
                this.validator.showMessageFor('city');
                this.validator.showMessageFor('zip/postalCode');
                this.validator.showMessageFor('termsandconditions');
            }
            this.setState({
                errors: errors,
                validationFired: true
            });
        }
    };

    getCCTypeId = () => {
        // Sets credit card type
        let ccTypeId = this.state.ccTypeId;
        switch (this.state.ccType) {
            case 'visa':
                ccTypeId = '1';
                break;
            case 'amex':
                ccTypeId = '2';
                break;
            case 'mastercard':
                ccTypeId = '4';
                break;
            case 'discover':
                ccTypeId = '3';
                break;
            default:
                break;
        }
        return ccTypeId;
    };

    checkCCExpiry = () => {
        // Get month and year from expiration date
        let currentMonth = parseInt((new Date().getMonth() + 1).toString());
        let currentYear = parseInt(new Date().getFullYear().toString().substring(2, 4));
        let month = parseInt(this.state.cardExpires.substring(0, 2));
        let year = parseInt(this.state.cardExpires.substring(2, 4));

        if (year < currentYear || (year === currentYear && month < currentMonth)) {
            return { isExpired: true, month: month, year: year };
        }
        return { isExpired: false, month: month, year: year };
    };

    processPayment = () => {
        let statusCode = '';
        const { billingAddress, mailingAddress, errors, states, clientId } = this.state;
        const contractId = this.state.contractDetails?.contractId;
        const ccTypeId = this.getCCTypeId();
        const cardDetails = this.checkCCExpiry();

        if (cardDetails.isExpired) {
            errors['ccExpired'] = true;
            this.setState({ errors: errors, searching: false });
            return;
        }
        // keep spinner active while fetching
        this.setState({
            searching: true,
            paymentAddress: billingAddress,
            ccTypeId: ccTypeId
        });

        const reqObj = {
            Amount: parseFloat(this.state.amount),
            CurrencyCode: 'USD',
            CountryCode: 'US',
            IsPreAuthCharge: false,
            CardHolder: {
                FirstName: this.state.firstName,
                LastName: this.state.lastName,
                BillingAddress: {
                    StreetAddress: billingAddress.address1,
                    Locality: billingAddress.city,
                    Region: states?.find((state) => {
                        return state.data === billingAddress.stateId;
                    }).abbreviation,
                    PostalCode: billingAddress.zip?.substring(0, 5),
                    ThreeLetterIsoCode: 'USA'
                },
                ShippingAddress: {
                    StreetAddress: mailingAddress.address1,
                    Locality: mailingAddress.city,
                    Region: states?.find((state) => {
                        return state.data === mailingAddress.stateId;
                    }).abbreviation,
                    PostalCode: mailingAddress.zip?.substring(0, 5),
                    ThreeLetterIsoCode: 'USA'
                }
            },
            CardInfo: {
                FullNumber: this.state.ccNumber.replace('-', ''),
                ExpirationMonth: parseInt(cardDetails.month),
                ExpirationYear: parseInt('20' + cardDetails.year),
                CreditCardVerificationNumber: this.state.securityCode,
                CardType: ccTypeId,
                CreditCardToken: this.state.ccNumberToken,
                CreditCardLastFour: this.state.creditCardLastFour
            },
            RelatedToIds: [contractId],
            RelatedTo: 1,
            ReferenceNumber: this.state.tokenExReferenceNumber,
            CultureName: 'en-US',
            Device: {
                Browser: navigator.userAgent,
                BrowserDetails: {
                    '3DSecureChallengeWindowSize': 'FULL_SCREEN',
                    acceptHeaders: 'application/json',
                    JavaEnabled: navigator.javaEnabled(),
                    Language: navigator.language,
                    ScreenHeight: window.screen.height.toString(),
                    ScreenWidth: window.screen.width.toString(),
                    ColorDepth: window.screen.colorDepth.toString(),
                    TimeZone: new Date().getTimezoneOffset().toString()
                }
            }
        };

        fetch('api/payment/'.concat(clientId), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqObj)
        })
            .then(function (res) {
                statusCode = res.status;
                return res.json();
            })
            .then((data) => {
                if (statusCode === 204) {
                    let errors = this.state.errors;
                    errors['general'] = true;
                    this.setState({ searching: false, errors: errors }, () => {
                        return;
                    });
                } else if (statusCode === 200) {
                    if (!data.isSuccessful) {
                        let errorsResponse = data.errors;
                        if (errorsResponse.length > 0) {
                            errorsResponse.map(function (error) {
                                if (error.errorCode === '9576') {
                                    errors['ccInvalid'] = true;
                                } else if (error.errorCode.includes('EXPIRED')) {
                                    errors['ccExpired'] = true;
                                } else if (error.errorCode.includes('FUND')) {
                                    errors['funds'] = true;
                                } else if (error.errorCode.includes('ADDRESS')) {
                                    errors['billingAddressMatch'] = true;
                                } else if (error.errorCode.includes('DECLINED')) {
                                    errors['declined'] = true;
                                } else {
                                    errors['general'] = true;
                                }
                            });

                            this.setState({ errors: errors, searching: false });
                            return;
                        }
                    } else {
                        const { billingAddress, mailingAddress, states, contractDetails, deviceData, clientId } =
                            this.state;

                        const reqObj = {
                            contractId: contractDetails?.contractId,
                            riskProfileId: deviceData?.activePlan?.riskProfileId,
                            amount: parseFloat(deviceData?.planPrice),
                            taxAmount: parseFloat(this.state.taxAmount),
                            firstName: this.state.firstName || '',
                            lastName: this.state.lastName || '',
                            phone: this.state.phone || '',
                            email: this.state.email || '',
                            billingAddress: {
                                address1: billingAddress.address1,
                                address2: billingAddress.address2,
                                city: billingAddress.city,
                                stateId: states?.find((state) => {
                                    return state.data === billingAddress.stateId;
                                })?.data,
                                zip: billingAddress.zip?.substring(0, 5)
                            },
                            mailingAddress: {
                                address1: mailingAddress.address1,
                                address2: mailingAddress.address2,
                                city: mailingAddress.city,
                                stateId: states?.find((state) => {
                                    return state.data === mailingAddress.stateId;
                                })?.data,
                                zip: mailingAddress.zip?.substring(0, 5)
                            },
                            devices:
                                deviceData?.deviceInfo?.map((item) => ({
                                    SerialNumber: item.serial,
                                    ClientAssetNumber: item.basicMaterial,
                                    OfferId: item.offerId,
                                    AssetId: item.assetId,
                                    PurchaseDate: item.purchaseDate,
                                    ConfigDescription: item.model,
                                    ExistingServicePlan: item?.plan
                                })) || []
                        };

                        fetch(`api/contract/create/unbundled/contract/${clientId?.toLowerCase()}`, {
                            method: 'post',
                            headers: {
                                'Content-Type': 'application/json',
                                XSRFTOKEN: this.state.cookies.XSRFTOKEN
                            },
                            body: JSON.stringify(reqObj)
                        }).then((res) => {
                            if (res.ok) {
                                res.json().then((data) => {
                                    this.props.history.push({
                                        pathname: '/confirmation/4',
                                        state: {
                                            amount: parseFloat(this.state.amount)?.toFixed(2),
                                            plan: deviceData?.selectedPlan || '',
                                            planNumber: data?.clientContractNumber || ''
                                        }
                                    });
                                });
                            } else {
                                console.error(res.status);
                            }
                        });
                    }
                }
            });
    };

    handleCancelSale = () => {
        this.props.history.push('/');
    };

    handleFindMy = () => {
        this.setState({
            enableFindMy: !this.state.enableFindMy
        });
    };

    render() {
        return (
            <BrandingContext.Consumer>
                {(context) => {
                    const { clientId } = context;
                    const { variableText } = getClientContent(clientId);
                    const phoneNumber = variableText.customerService.phone;
                    document.title = getMetaDataByClient(clientId, 'Payment').title;
                    const dynamicContent = variableText?.salesConfig || {};
                    return (
                        <div className='container contentWrapper'>
                            <Form>
                                <Row>
                                    <Col
                                        md='7'
                                        lg='7'
                                        mb='6'
                                    >
                                        <Col
                                            md='9'
                                            className='p-0 mb-3'
                                        >
                                            <h2 className={classNames('h5 mb-4')}>Payment Information</h2>
                                            {/* payment type toggle */}
                                            {/*<PaymentToggle*/}
                                            {/*    state={this.state}*/}
                                            {/*    onClick={(val) => this.setState({ paymentType: val })}*/}
                                            {/*/>*/}
                                            {/* based on the payment type view will change */}
                                            {this.state.paymentType === 'cardPayment' ? (
                                                <React.Fragment>
                                                    <PaymentInputs
                                                        state={this.state}
                                                        handleInputChange={this.handleInputChange}
                                                        validator={this.validator}
                                                        ccTypeChanged={this.ccTypeChanged}
                                                    />
                                                    <PaymentBillingInfo
                                                        state={this.state}
                                                        handleInputChange={this.handleInputChange}
                                                        validator={this.validator}
                                                        handleStateDropDown={this.handleStateDropDown}
                                                        handleCheckAddress={this.handleCheckAddress}
                                                        whiteLabelBrand={clientId}
                                                    />
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <PaymentAccountInputs
                                                        state={this.state}
                                                        handleInputChange={this.handleInputChange}
                                                        validator={this.validator}
                                                    />
                                                    <PaymentBillingInfo
                                                        state={this.state}
                                                        handleInputChange={this.handleInputChange}
                                                        validator={this.validator}
                                                        handleStateDropDown={this.handleStateDropDown}
                                                        handleCheckAddress={this.handleCheckAddress}
                                                        whiteLabelBrand={clientId}
                                                    />
                                                </React.Fragment>
                                            )}
                                        </Col>

                                        {dynamicContent?.showAnnualBilling && (
                                            <>
                                                <h1 className='h5 mb-1'>
                                                    <b>Get at least 1 Month Free with Annual Billing </b>
                                                </h1>
                                                <FormGroup>
                                                    <CheckboxInput
                                                        clientId={clientId}
                                                        id='payAnnually'
                                                        checked={this.state.payAnnual}
                                                        handleCheck={this.handleAnnualPay}
                                                    >
                                                        Pay Annually (${this.state.annualPayAmount}/year)
                                                        <AIGStatusBadge
                                                            statusId={1}
                                                            statusType='annualPay'
                                                            customClass={styles.savingsBadge}
                                                        />
                                                    </CheckboxInput>
                                                </FormGroup>
                                            </>
                                        )}

                                        <FormGroup>
                                            <CheckboxInput
                                                clientId={clientId}
                                                id='termsandconditions'
                                                checked={this.state.termsAccepted}
                                                handleCheck={this.handleTermsToggle}
                                                customClass='mb-2'
                                            >
                                                I have read and accept the {variableText?.planName}
                                                <a
                                                    href={this.state.coverageDocsLink}
                                                    className={styles.link}
                                                    target='_blank'
                                                >
                                                    &nbsp;terms and conditions
                                                </a>
                                                .
                                            </CheckboxInput>
                                            {this.validator.message(
                                                'termsandconditions',
                                                this.state.termsAccepted,
                                                'required|terms',
                                                {
                                                    messages: {
                                                        default: 'Please accept terms and conditions before proceeding.'
                                                    }
                                                }
                                            )}
                                        </FormGroup>

                                        {dynamicContent?.showFindMyCheckbox && (
                                            <FormGroup>
                                                <CheckboxInput
                                                    clientId={clientId}
                                                    id='enableFindMy'
                                                    checked={this.state.enableFindMy}
                                                    handleCheck={this.handleFindMy}
                                                >
                                                    I understand theft and loss coverage requires me to have
                                                    <a
                                                        className='ml-1 mr-1'
                                                        href='https://www.apple.com/icloud/find-my/'
                                                        target='_blank'
                                                    >
                                                        Find My
                                                    </a>
                                                    enabled on my device at the time it is lost or stolen and must
                                                    remain enabled throughout the claim process.
                                                </CheckboxInput>
                                                {this.validator.message(
                                                    'enableFindMy',
                                                    this.state.enableFindMy,
                                                    'required|enableFindMy',
                                                    {
                                                        messages: {
                                                            default:
                                                                'Please affirm you understand Theft and Loss coverage requires Find My to be enabled.'
                                                        }
                                                    }
                                                )}
                                            </FormGroup>
                                        )}
                                        {this.state.paymentError && (
                                            <p className={styles.paymenErrorWrapper}>Failed to process the payment</p>
                                        )}
                                        <>
                                            {this.state.errors.billingAddressMatch && (
                                                <div className='validationSummary'>
                                                    The billing address does not match the cards records.
                                                </div>
                                            )}
                                            {this.state.errors.funds && (
                                                <div className='validationSummary'>
                                                    Unfortunately there are not enough funds available on this card.
                                                    Please try paying with a different card.
                                                </div>
                                            )}
                                            {this.state.errors.declined && (
                                                <div className='validationSummary'>
                                                    The credit card entered was declined, please try paying with a
                                                    different credit card.
                                                </div>
                                            )}
                                            {this.state.errors.general && (
                                                <div className='validationSummary'>
                                                    There was an issue processing your payment. Please try again.
                                                </div>
                                            )}
                                        </>
                                        <Col className='mt-3 px-0 mb-3'>
                                            <div className={styles.paymentBtnWrapper}>
                                                <SpinnerButton
                                                    className='ml-3'
                                                    type='primary'
                                                    text={`Pay $${this.state.amount}`}
                                                    disabled={this.state.searching}
                                                    spinning={this.state.searching}
                                                    onClick={this.continue}
                                                    ariaLabel='Click pay and submit to pay deductible and complete claim setup or continue tabbing to review your claim summary'
                                                />
                                                <button
                                                    className='btn btn-secondary mb-0'
                                                    onClick={this.handleBackbutton}
                                                >
                                                    Back
                                                </button>
                                            </div>
                                            {dynamicContent?.showCancelSale && (
                                                <div className={styles.btnContainer}>
                                                    <a
                                                        className='btnLink'
                                                        aria-label='Opens a modal to cancel sale'
                                                        onClick={() => this.setState({ showCancelSaleModal: true })}
                                                    >
                                                        Cancel Sale
                                                    </a>
                                                </div>
                                            )}
                                            {dynamicContent?.showSaveSale && (
                                                <div className={styles.saveLaterBtn}>
                                                    <a
                                                        href='#'
                                                        onClick={this.handleShowActionModal}
                                                        className={classNames('btn', btnLink, styles.saveForLater)}
                                                        aria-label='Opens a modal to save your information'
                                                    >
                                                        Save For Later
                                                    </a>
                                                </div>
                                            )}
                                        </Col>
                                    </Col>
                                    <Col
                                        className='mb-3'
                                        md={{ size: '5', offset: 0 }}
                                        lg={{ size: '5', offset: 0 }}
                                        xs={{ size: '12', order: 2 }}
                                    >
                                        <OrderSummary
                                            updateTotal={this.updateAmount}
                                            updatePlanData={this.updatePlanData}
                                            promoCodeUpdate={this.updatePromoCode}
                                            payAnnual={this.state.payAnnual}
                                            payAmount={(payAmount) => this.updatePayAmount(payAmount)}
                                            showDetails={true}
                                            clientId={this.state.clientId}
                                        />
                                        {dynamicContent?.showCallBanner && <CallBanner phoneNumber={phoneNumber} />}
                                    </Col>
                                </Row>
                                {this.state.ShowSaveModal && (
                                    <SaveModal
                                        isOpen={true}
                                        centered={true}
                                        toggle={() => this.handleToggle(false)}
                                        customerData={this.getCustomerData()}
                                        planData={this.getPlanData()}
                                        clientId={this.state.clientId}
                                        isSavedForLater={this.handleSavedData}
                                        comingFrom={'Payment'}
                                        isAgent={this.state.isAgent}
                                        promoCodeData={this.state.promoCode}
                                    />
                                )}
                                {this.state.showCancelSaleModal && (
                                    <CancelSaleModal
                                        toggle={() => this.setState({ showCancelSaleModal: false })}
                                        isOpen={this.state.showCancelSaleModal}
                                        cancelAction={this.handleCancelSale}
                                    />
                                )}
                            </Form>
                        </div>
                    );
                }}
            </BrandingContext.Consumer>
        );
    }
}
